import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/auth'
import 'firebase/compat/functions'

const firebaseConfig = {
  apiKey: "AIzaSyCBsX2LFeYuMsvu_Cy8oUAuQb7rat1w9Ls",
  authDomain: "your-fred.firebaseapp.com",
  projectId: "your-fred",
  storageBucket: "your-fred.appspot.com",
  messagingSenderId: "879973766692",
  appId: "1:879973766692:web:ac92ef066426d713a92ab1"
};

firebase.initializeApp(firebaseConfig);

firebase.firestore().settings({
    ignoreUndefinedProperties: true
})

export const firestore = firebase.firestore
export const db = firebase.firestore()
export const auth = firebase.auth()
export const functions = firebase.app().functions()

global.db = firebase.firestore()